import { NgModule } from '@angular/core';
import { ChipsLegendInputComponent } from './chipsLegendInput.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from '../autoComplete/autoComplete.module';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  imports: [CommonModule, AppMaterialModule, FormsModule, ReactiveFormsModule, AutoCompleteModule, FlexLayoutModule],
  exports: [ChipsLegendInputComponent],
  declarations: [ChipsLegendInputComponent],
  providers: []
})
export class ChipsLegendInputModule {}
